import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import safety from '@devices/settings/device_settings/safety.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellyem',
	friendly_name: 'EM',
	family: 'emeter',
	isPM: true,
	modes: {
		emeter: {
			channels: 2,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage', 'overtemperature'],
			phases: 2,
			settings: [
				timer,
				schedule,
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'wifi_ap_roaming', component: 'wifi_ap_roaming' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{ title: 'cloud', component: 'cloud' },
					],
				},
				safety,
				{
					title: 'application_settings',
					components: [
						{ title: 'ai_model', component: 'ai_model' },
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'appliance_type', component: 'appliance_type' },
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
						{
							title: 'consumption_hierarchy',
							component: 'consumption_hierarchy',
							test_user: true,
						},
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'transformer_type', component: 'transformer_type' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'erase_data', component: 'erase_data' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
